import { IOption } from "@/view-models/IFormData";

export interface SearchCmsData {
    searchbarPlaceholder: string;
    resultsForText: string;
    showMoreText: string;
    searchButtonText: string;
    readMoreText: string;
}

export interface NewsCmsData {
    showMoreFilters: string;
    showLessFilters: string;
    readMore: string;
    popularThemes: string;
}

export interface SportEducationsCmsData {
    title: string;
    showMoreText: string;

    educationsText: string;
    linkUrl: string;
    linkTarget: string;
    linkText: string;
    grouping?: string;
}

export interface ContactCmsData {
    pageId: number;
    title: string;
    introText: string;
    requiredLabel: string;
    messageLabel: string;
    firstNameLabel: string;
    lastNameLabel: string;
    emailLabel: string;
    phoneLabel: string;
    generalTermsInputLabel: string;
    optInInputLabel: string;
    requiredFieldMessage: string;
    invalidEmailMessage: string;
    sendButtonText: string;
    successMessage: string;
    errorMessage: string;
    captchaSiteKey: string;
}

export interface EducationEnrollCmsData {
    educationId: number;
    sessionId: number;
    title: string;
    informationSubtitle: string;
    informationTitle: string;
    costLabel: string;
    costValue: string;
    locationLabel: string;
    locationValue: string,
    locationStreet: string,
    locationPostalCode: string,
    locationPlace: string,
    locationName: string,
    locationUrl: string;
    meetingLabel: string;
    meetingValue: string;
    
    startDateTitle: string;
    startDateLabel: string;
    startDates: IOption[];
    sessions: IOption[];
    chooseStartDate: string;

    personalDataTitle: string;
    firstNameLabel: string;
    infixLabel: string;
    lastNameLabel: string;
    postalCodeLabel: string;
    houseNumberLabel: string;
    streetLabel: string;
    cityLabel: string;
    phoneLabel: string;
    emailLabel: string;

    addPeopleTitle: string;
    addPeopleIntroText: string;
    addPersonButtonText: string;
    addOtherPersonButtonText: string;
    removePersonButtonText: string;

    associationDataTitle: string;
    associationNameLabel: string;
    sportsAssociationLabel: string;
    whenDifferentLabel: string;
    sourceLabel: string;

    generalTermsInputLabel: string;
    optInInputLabel: string;

    noSportsAssociationLabel: string;

    bondenData: IOption[];
    sourceData: IOption[];

    requiredFieldMessage: string;
    invalidEmailMessage: string;
    invalidPhoneMessage: string;
    
    afterFormText: string;
    sendButtonText: string;

    successMessage: string;
    errorMessage: string;

    captchaSiteKey: string;

    fontColor: string,
    headerColor: string,
    buttonColor: string,
    headerFontColor: string,
    headerFontMarkColor: string,
    logo: string,
    logoDescription: string,

    formType: FormType;
}

export enum FormType {
    NORMAL = "NORMAL",
    RABOBANK = "RABOBANK",
    BADMINTON = "BADMINTON",
    VOEDINGSCONGRES = "VOEDINGSCONGRES",
    VOEDINGSCONGRES_EN = "VOEDINGSCONGRES_EN",
}

export interface SearchHeaderCmsData {
    searchHeaderTitle: string;
    searchHeaderPlaceholder: string;
    searchHeaderButtonText: string;
    searchHeaderLinkText: string;
    searchHeaderLinkUrl: string;
    searchHeaderButtonLinkText: string;
    searchHeaderButtonLinkUrl: string;
    mostBookedCoursesTitle: string;
    mostBookedCourses: Course[];
}

export interface Course {
    url: string;
    title: string;
}

export interface EducationOverviewCmsData extends SearchHeaderCmsData {
    filterTitle: string;
    chosenFiltersTitle: string;
    moreLabel: string;
    lessLabel: string;
    enrollLinkText: string;
    externalLinkText: string;
    readMoreLabel: string;
    filterMobileLabel: string;
    sortOnLabel: string;
    sortOnMobileLabel: string;
    sortAlphabeticallyAscLabel: string;
    sortAlphabeticallyDescLabel: string;
    resultsLabel: string;
    resultsForLabel: string;
    loadMoreLabel: string;
}

class CmsDataProvider {
    private data: Record<string, any>;
    constructor() {
        this.data = (window as any).__CMS_DATA || {};
    }

    get<T>(id: string): T {
        const data = this.data[id];
        if (!data) {
            throw new TypeError(`no data available for id: '${id}'`);
        }
        return data;
    }
}

export default new CmsDataProvider();
